export default __webpack_public_path__ + "static/media/sample-scratch-ticket.074b70ba.png";